import React from "react";
import { Jumbotron, Container } from "reactstrap";
import "../assets/styles/Banner.scss";

const Banner = ({ title, subtitle, bg }) => (
  <Jumbotron
    style={{
      background: `url(${require("../assets/img/" +
        bg)}) no-repeat center center`,
    }}
  >
    <Container className="banner">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </Container>
  </Jumbotron>
);

export default Banner;
